import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

import { ModalController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
@Component({
  selector: 'app-search-products',
  templateUrl: './search-products.component.html',
  styleUrls: ['./search-products.component.scss'],
})
export class SearchProductsComponent implements OnInit {
  search_down = false;
  keyword;
  active_dropdwon = 0;
  
  // empty_search_productss = []
  search_value = true;
  // product_list;
  show_category;

  @Input() search_page;
  @ViewChild('search_dropdown') search_dropdown:any = ElementRef;
  constructor(public db:DataService,public router:Router,public storage:Storage) { }

  ngOnInit() {
    this.db.get_values(); 
    // this.get_pos_all_products();
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event) { 
    if(this.search_down && this.db.search_productss.length != 0){
      
      if(event.key == 'ArrowDown'){ 
        (this.db.search_productss.length - 1 ) >  this.active_dropdwon ?  this.active_dropdwon += 1 : null
        // console.log('down',this.active_dropdwon)
        
      } else if(event.key == 'ArrowUp') {
        this.active_dropdwon != 0 ?  this.active_dropdwon -= 1 : null;
        // console.log('down',this.active_dropdwon)
        // this.searching_down.nativeElement.scrollIntoView({behavior: "smooth", block: "start",inline: "nearest"});
      }else if( event.key == 'Enter'){
         this.selected_products(this.db.search_productss[this.active_dropdwon]);
         this.keyword = '';
         // console.log('down',this.active_dropdwon)
      }

    // if(document.getElementById('container_div_id').scrollHeight >document.getElementById('container_div_id').clientHeight ){
         let check = document.getElementById(this.active_dropdwon+'s') as HTMLInputElement
         check.scrollIntoView({ behavior: "smooth", block: "start",  inline: "nearest" });
    // }
      
      // this.searching_down.nativeElement.scrollIntoView({behavior: "smooth", block: "start",inline: "nearest"});
    }
    
    // if(this.location_dropdown && this.db.location_sugesstions.length != 0){
    //   if(event.key == 'ArrowDown'){ 
    //     (this.db.location_sugesstions.length - 1)>  this.active_dropdwon ?  this.active_dropdwon += 1 : null
    //   } else if(event.key == 'ArrowUp') {
    //     this.active_dropdwon != 0 ?  this.active_dropdwon -= 1 : null
    //     // this.searching_down.nativeElement.scrollIntoView({behavior: "smooth", block: "start",inline: "nearest"});
    //   } else if( event.key == 'Enter'){
    //     this.db.validate_location(this.db.location_sugesstions[ this.active_dropdwon])
    //     this.db.location_sugesstions = []
    //   }
    //   document.getElementById(this.active_dropdwon+'d').scrollIntoView({ behavior: "smooth", block: "start",  inline: "nearest" });
    //   // this.searching_down.nativeElement.scrollIntoView({behavior: "smooth", block: "start",inline: "nearest"});
    // }


    // let key = event.key;
    // let current_active = this.active;
    // if(key=='ArrowDown'){      
    //     if((current_active + 1) < this.db.category.length){
    //       this.active = current_active + 1;
    //       // this.goto(this.db.category[this.active],'child-1',this.active);          
    //     }
    // }else if(key=='ArrowUp'){
    //     if((current_active - 1) < this.db.category.length && (current_active-1) != -1){
    //       this.active = current_active - 1;
    //       // this.goto(this.db.category[this.active],'child-1',this.active);          
    //     }
    // }
  }


  @HostListener('document:click', ['$event'])
  clickout(event) {
// && this.search_productss.length != 0
    this.search_dropdown && !this.db.ismobile  && !this.search_dropdown.nativeElement.contains(event.target) ? (this.db.search_productss = [] , this.keyword ='',this.search_value = false,this.show_category = false) : null      

    
    // if(!this.location_dropdown){
    //   this.location_container && this.db.locationpopup && !this.location_container.nativeElement.contains(event.target) ? this.db.locationpopup = false : null
    // } else {
    //   this.location_container && this.db.locationpopup && !this.location_container.nativeElement.contains(event.target) ? this.location_dropdown = false : null
    // }
    // if(){
    //   if() {
    //       if(this.location_dropdown ){
    //           // console.log(this.locations.nativeElement.contains(event.target))
              
    //       }
    //       // && this.locations && !this.locations.nativeElement.contains(event.target)
    //       //  else {
    //           // this.location_dropdown = false
    //       // }
    //   } else { 

    //     // if(this.location_dropdownn && this.location_dropdown && this.location_dropdownn.nativeElement.contains(event.target)) {
    //     //   // 
    //     // } else {
    //     //   this.db.locationpopup = false
    //     // }
    //   }
    // }

    // if(this.location_dropdownn && this.location_dropdown){
    //   if(this.location_dropdownn.nativeElement.contains(event.target)) {
    //   } else {
    //     this.location_dropdown = false
    //   }
    // }

    // if(this.locations && this.location_dropdown){
    //   if(this.locations.nativeElement.contains(event.target)) {
    //   } else {
    //     this.location_dropdown = false
    //   }
    // }
  } 

  icon_searchproduct(d){
   
    if (this.keyword != '' && this.keyword != undefined) {
      // this.db.search_productss = [];
      // this.search_value = false;
      this.searchproduct(d);
      // this.router.navigateByUrl('/search/' + this.keyword);
      
    }
  }


  searchproduct(d) {
    // console.log(d)
    this.search_value = true;
    if (this.keyword != '' && this.keyword != undefined) {
      // this.searchproducts(this.keyword);
      // this.active_dropdwon = 0
      this.db.search_txt =this.keyword;
      this.db.inventory_page_no =  1;
      this.db.get_values();
      // this.db.search_productss = this.db.inventory;
      // this.router.navigate(['/search'], { queryParams: { q: this.keyword } });
    }else{
      this.db.search_productss = [];
      // this.db.search_txt =this.keyword;
      // this.db.inventory_page_no =  1;
      // this.db.get_values();
    }
  }

  
  get_pos_all_products(){
    if(localStorage['domain_customerId'] != undefined){
    this.storage.get('selectmenu').then((val) => {
      // this.product_list = val;
    });
  }
  }


  searchproducts(searchTerm) {
    this.db.search_productss = this.db.inventory.filter(obj => (obj.item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) || (obj.sku ? obj.sku.indexOf(searchTerm.toLowerCase()) > -1 : ''))
    // console.log(this.db.search_productss)
    // return this.all_products.filter((item) => {
    //   return item.item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    // });
  }


// GoogleAutocomplete;
// getPlaceAutocomplete(event) {
//   console.log(this.keyword)

  
//   console.log("loading loading..")
//   this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
//   this.GoogleAutocomplete.getPlacePredictions({ input: this.keyword, componentRestrictions: {country: 'IN'} },
//   (predictions, status) => {
//     // this.autocompleteItems = [];
//     this.zone.run(() => {
//       predictions.forEach((prediction) => {
//       console.log(prediction)
//       });
//     });
//   });


//   const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
//       {
//           componentRestrictions: { country: 'IN' },
//           types: ['address']  // 'establishment' / 'address' / 'geocode'
//       });
//       google.maps.event.addListener(autocomplete, 'place_changed', () => {
//           const place = autocomplete.getPlace();
//           console.log(place)
//       });
// }

 selected_products(item){
  // console.log(item)
  this.db.search_productss = [];
  this.search_value = false;
  
  // if(this.db.selected_items.length != 0){
   
  //   let data = this.db.selected_items.find(r=> r.name == item.name);
   
  //   item.qty = 0;
  //    data ? this.db.alert('Selected product is already added') : this.db.selected_items.push(item);
  //    console.log(this.db.selected_items)
  // }else{
  //   item.qty = 0
  //   this.db.selected_items.push(item);
  //   console.log(this.db.selected_items)
  // }
         
  if(this.db.selected_items.length != 0){
         
    this.db.inventory.map(res=>{
     if(item.attribute_id){
      if(res.attribute_id == item.attribute_id){
        res.qty = 1;
        // console.log(res.attribute_id);
        // console.log(this.db.selected_items);
        let data = this.db.selected_items.find(r=> r.attribute_id == item.attribute_id);
        // console.log(data);
        data ? this.db.added_animate.next('Selected product is already added') : this.db.selected_items.push(res);
        // console.log(this.db.selected_items);
      }
     }else{
      if(res.name == item.name){
        res.qty = 1;

        // this.db.alert('Selected product is already addedd') 

        let data = this.db.selected_items.find(r=> r.name == item.name);
        data ?  this.db.added_animate.next('Selected product is already added') : this.db.selected_items.push(res);
        console.log(this.db.selected_items);
      }
    }
  });
      
  }else {

    this.db.inventory.map(res=>{

     if(item.attribute_id){    
       if(res.attribute_id == item.attribute_id){
        res.qty = 1;
        this.db.selected_items.push(res);
        // this.open_insert_slot();
       }
      }else{
         if(res.name == item.name){
          res.qty = 1;
          this.db.selected_items.push(res);
          // this.open_insert_slot();
        }
     }

    })
    
  }

  

 }

}
